<form #ngF="ngForm" [formGroup]="form" class="k-form-inline" #pForm>

  <div class="k-form-field">
    <label for="project_name" class="form-label col-3">Project Name</label>
    <div class="col-8">
      <input appAutoFocus type="text" id="project_name" formControlName="project_name" class="form-control">
      <div *ngIf="project_name?.invalid" class="alert alert-danger">
        <div *ngIf="project_name?.errors?.['required']">Project Name is required.</div>
      </div>
    </div>
  </div>

  <div class="k-form-field">
    <label for="contact_person" class="form-label col-3">Contract Person</label>
    <div class="col-8">
      <input type="text" id="contact_person" formControlName="contact_person" class="form-control">
    </div>
  </div>

  <div class="k-form-field">
    <label for="contact_email" class="form-label col-3 k-label">Contact Email</label>
    <div class="col-8">
      <input type="contact_email" id="contact_email" formControlName="contact_email" class="form-control">
      <div *ngIf="contact_email?.invalid && (contact_email?.dirty || contact_email?.touched)"
        class="alert alert-danger">
        <div *ngIf="contact_email?.errors && contact_email?.errors?.['email']">Please enter a valid contact email address.</div>
      </div>
    </div>
  </div>

  <div class="k-form-field">
    <label for="contact_telephone" class="form-label col-3">Contact Telephone</label>
    <div class="col-8">
      <input type="text" id="contact_telephone" formControlName="contact_telephone" class="form-control">
      <div *ngIf="contact_telephone?.invalid && (contact_telephone?.dirty || contact_telephone?.touched)"
        class="alert alert-danger">
        <div *ngIf="contact_telephone?.errors && contact_telephone?.errors?.['pattern']">Invalid Phone
          Number.</div>
      </div>
    </div>
  </div>

  <div class="k-form-field">
    <label for="funding_body" class="form-label col-3">Funding Body</label>
    <div class="col-8">
      <input type="text" id="funding_body" formControlName="funding_body" class="form-control">
    </div>
  </div>

  <div class="k-form-field">
    <label for="project_amount" class="form-label col-3">Project Amount</label>
    <div class="col-8">
      <!-- <kendo-numerictextbox #currentyFormat [format]="formatOptions" [min]="0"
        formControlName="project_amount"></kendo-numerictextbox> -->
      <input type="number" id="project_amount" formControlName="project_amount" class="form-control">
    </div>
  </div>

  <div class="k-form-field">
    <label for="development_amount" class="form-label col-3">Development Amount</label>
    <div class="col-8">
      <input type="number" id="development_amount" formControlName="development_amount" class="form-control">
    </div>
  </div>

  <div class="k-form-field">
    <label for="dev_url" class="form-label col-3">Development URL</label>
    <div class="col-8">
      <input type="text" id="dev_url" formControlName="dev_url" class="form-control">
    </div>
  </div>

  <div class="k-form-field">
    <label for="uat_url" class="form-label col-3">UAT URL</label>
    <div class="col-8">
      <input type="text" id="uat_url" formControlName="uat_url" class="form-control">
    </div>
  </div>

  <div class="k-form-field">
    <label for="prod_url" class="form-label col-3">Production URL</label>
    <div class="col-8">
      <input type="text" id="prod_url" formControlName="prod_url" class="form-control">
    </div>
  </div>

  <div class="k-form-field">
    <label for="postgresql_ver" class="form-label col-3">PostgreSQL Version</label>
    <div class="col-8">
      <input type="text" id="postgresql_ver" formControlName="postgresql_ver" class="form-control">
    </div>
  </div>


  <div class="d-grid d-md-flex justify-content-md-end">
    <button type="button" class="btn btn-primary me-md-2" (click)="onSubmit()" [disabled]="form.invalid">Save</button>

    <button type="button" class="btn btn-secondary" (click)="closeWindow()"> Cancel</button>
  </div>

</form>
